<pace-forms-accordion
    *ngrxLet="measuringEquipments$ as measurementEquipments"
    group="measurementEquipments"
    [open]="measurementEquipmentsOpen"
    (openChange)="measurementEquipmentsOpenChanged($event)"
>
    <ng-template #heading>
        <span class="content-icon {{ updateMeasurementEquipmentsStatus(measurementEquipments) }}"></span>
        <span>{{ measurementEquipments.heading }} ({{ rowsWithData + '/' + totalRows }})</span>
    </ng-template>
    <ng-template #body>
        @if (measurementEquipments) {
            <div class="row">
                <div>
                    <div class="col-9">
                        @if (measurementEquipments.header.visibility) {
                            <div class="row">
                                @for (column of measurementEquipments.header.columns; track column) {
                                    <span
                                        class="d-none d-sm-block col-form-label text-center"
                                        id="column.id"
                                        [ngClass]="measurementEquipments.header.columns.length > 3 ? 'col-3' : 'col-4'"
                                    >
                                        {{ column.columnName }}
                                    </span>
                                }
                            </div>
                        }
                    </div>
                    @for (row of measurementEquipments.rows; track trackByRowId(i, row); let i = $index) {
                        @if (row.visibility) {
                            <div class="row">
                                @if (i === 0) {
                                    <div class="d-sm-none text-start">
                                        <div class="not-applicable">
                                            <div class="checkbox-container">
                                                <input
                                                    type="checkbox"
                                                    id="{{ measurementEquipments.id }}-option-not-applicable"
                                                    [checked]="measurementEquipments.noMeasurementToolsUsed"
                                                    (change)="
                                                        noMeasurementToolsUsed(
                                                            measurementEquipments.rows[0].rowId,
                                                            $event
                                                        )
                                                    "
                                                />
                                                <label for="{{ measurementEquipments.id }}-option-not-applicable">
                                                    @if (measurementEquipments.noMeasurementToolsUsed) {
                                                        <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                                                    }
                                                </label>
                                            </div>
                                            <label
                                                translate="F4M_NOT_APPLICABLE_LABEL"
                                                for="{{ measurementEquipments.id }}-option-not-applicable"
                                            ></label>
                                        </div>
                                    </div>
                                }
                                @if (i !== 0) {
                                    <div class="actions d-sm-none">
                                        <div
                                            class="col-12 col-lg-1 limited-col-width pe-1 text-end d-flex justify-content-end align-items-start mt-2"
                                        >
                                            <button
                                                class="btn btn-warning"
                                                (click)="deleteRow(row.rowId)"
                                                [attr.aria-label]="
                                                    'MEASUREMENT_EQUIPMENT_DELETE_ROW_ARIA_LABEL' | translate
                                                "
                                            >
                                                <fa-icon [icon]="faTrashAlt"></fa-icon>
                                            </button>
                                        </div>
                                    </div>
                                }
                                <pace-forms-measuring-equipments-input-row
                                    [row]="row"
                                    class="col-sm-9 col-12"
                                    [noMeasurementToolsUsed]="measurementEquipments.noMeasurementToolsUsed"
                                    [disabled]="measurementEquipments.noMeasurementToolsUsed || (readOnly$ | async)"
                                ></pace-forms-measuring-equipments-input-row>
                                @if (i === 0) {
                                    <div class="actions col-3 d-sm-flex d-none">
                                        <button
                                            [disabled]="
                                                measurementEquipments.noMeasurementToolsUsed || (readOnly$ | async)
                                            "
                                            [ngClass]="
                                                measurementEquipments.noMeasurementToolsUsed || (readOnly$ | async)
                                                    ? 'disabled'
                                                    : ''
                                            "
                                            class="add-btn"
                                            (click)="addRow(measurementEquipments.rows)"
                                            [attr.aria-label]="'MEASUREMENT_EQUIPMENT_ADD_ROW_ARIA_LABEL' | translate"
                                        >
                                            &#43;
                                        </button>
                                        <div
                                            class="col-sm-6 col-12 ps-sm-2"
                                            [ngClass]="(readOnly$ | async) ? 'disabled' : ''"
                                        >
                                            <div class="not-applicable">
                                                <div class="checkbox-container">
                                                    <input
                                                        type="checkbox"
                                                        id="{{ measurementEquipments.id }}-not-applicable"
                                                        [checked]="measurementEquipments.noMeasurementToolsUsed"
                                                        (change)="
                                                            noMeasurementToolsUsed(
                                                                measurementEquipments.rows[0].rowId,
                                                                $event
                                                            )
                                                        "
                                                        [disabled]="readOnly$ | async"
                                                    />
                                                    <label for="{{ measurementEquipments.id }}-not-applicable">
                                                        @if (measurementEquipments.noMeasurementToolsUsed) {
                                                            <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                                                        }
                                                    </label>
                                                </div>
                                                <label
                                                    translate="F4M_NOT_APPLICABLE_LABEL"
                                                    for="{{ measurementEquipments.id }}-not-applicable"
                                                ></label>
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (i !== 0) {
                                    <div class="actions col-3 d-none d-sm-block mt-4">
                                        <button
                                            [disabled]="
                                                measurementEquipments.noMeasurementToolsUsed || (readOnly$ | async)
                                            "
                                            class="add-btn"
                                            (click)="deleteRow(row.rowId)"
                                            [disabled]="readOnly$ | async"
                                            [ngClass]="(readOnly$ | async) ? 'disabled' : ''"
                                            [attr.aria-label]="
                                                'MEASUREMENT_EQUIPMENT_DELETE_ROW_ARIA_LABEL' | translate
                                            "
                                        >
                                            &#8722;
                                        </button>
                                    </div>
                                }
                                <div class="border-bottom d-sm-none"></div>
                            </div>
                        }
                    }
                    <div class="position-relative d-sm-none">
                        <hr class="separator" />
                        <button
                            [disabled]="measurementEquipments.noMeasurementToolsUsed || (readOnly$ | async)"
                            [ngClass]="measurementEquipments.noMeasurementToolsUsed ? 'disabled' : ''"
                            (click)="addRow(measurementEquipments.rows)"
                            class="add-entry-round-btn d-flex align-items-center justify-content-center rounded-circle btn btn-primary rounded-circle position-absolute start-50 top-50 translate-middle"
                            [attr.aria-label]="'MEASUREMENT_EQUIPMENT_ADD_ROW_ARIA_LABEL' | translate"
                        >
                            <fa-icon [icon]="faPlus"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
        }
    </ng-template>
    <ng-template #closer>
        <div role="link" translate="F4M_RENDERER_FRONT_MEASUREMENT_EQUIPMENTS"></div>
    </ng-template>
</pace-forms-accordion>
